
import {Component} from 'react';
import DropDownOptionCard from "../shared-components/drop_down_option_card";

class CarChangeModalInput extends Component {
  constructor(props) {
    super(props);
  }
  
  render(){
      if (this.props.cashDownOptions === true){
          this.cashDownOptions = this.props.cashDownOptionsArr.map((optionsList,index) =>
            <DropDownOptionCard options={optionsList} key={index} />
            );
      }

      let displayType = "";
      let combinedText = "";
      if (this.props.cashDownOptions === true && this.props.tradeInOption === true){
          displayType = "displayBoth";
          combinedText = this.props.cashDownText + " " + this.props.tradeInOptionText;
      }else{
         if (this.props.cashDownOptions === true){
              displayType = "displayCashOptions";
         }
         if (this.props.tradeInOption === true){
              displayType = "displayTradeInOption";
         }
      }
    
  return <>
      <div>
         {displayType === "displayBoth"   ?
            <>
              <div className="mt-2 mx-2">
                  <div>{combinedText}</div>
                  <div className="row mt-2">
                        <div className = "col-7">
                            <label className="font-weight-bold mx-2" htmlFor="downPayment">Cash Down:&nbsp;</label>
                            <select onChange={(val) => this.props.handleDownPaymentChange(val.target.value)}
                              value={this.props.downPaymentAmt}
                              className="btn btn-sm btn-outline-secondary dropdown-toggle" id="downPayment"  >
                                {this.cashDownOptions}
                            </select>
                        </div>
                        <div className= "col-5">
                              <input type="checkbox" id="tradeIn" name="tradeIn" checked={this.props.applyTradeIn}
                                onChange={(val) => this.props.handleTradeInChange(val.target.checked)}/>
                              <label htmlFor="tradeIn">&nbsp;&nbsp; Apply Trade-In Value to Car Loan</label> 
                        </div>
                    </div>
                </div>
              </>
          :
              null
          }
          {displayType === "displayCashOptions" ?
                <>
                  <div className="mt-2 mx-2">
                      <div>{this.props.cashDownText}</div>
                  <label className="font-weight-bold mx-2" htmlFor="downPayment">Cash Down:&nbsp;</label>
                      <select onChange={(val) => this.props.handleDownPaymentChange(val.target.value)}
                        value={this.props.downPaymentAmt}
                        className="btn btn-sm btn-outline-secondary dropdown-toggle" id="downPayment"  >
                          {this.cashDownOptions}
                      </select>
                  </div>
                </>
            :
                null
            }
            {displayType === "displayTradeInOption"   ?  
                <div>
                    <div>
                      {this.props.tradeInOptionText}
                    </div>
                    <input type="checkbox" id="tradeIn" name="tradeIn" checked={this.props.applyTradeIn}
                        onChange={(val) => this.props.handleTradeInChange(val.target.checked)}/>
                    <label htmlFor="tradeIn">&nbsp;&nbsp; Apply Trade-In Value to Car Loan</label> 
                </div>
            :
              null
            }
  
      </div>
  </>
  }
}
export default CarChangeModalInput;